import mergeObj from '../extraUtil/mergeTwoObj';

let chart = {
    "showLabels": "1",
    "showvalues":"1",
    "plotBorderThickness":"1",
    "showparent":"0",
    "plotbordercolor":"#27293d",
    "plotfillalpha":"10",
    "plotfillhoveralpha":"100",
    "plotToolText": "<div><b>$label</b><br/> <b>Shipments: </b>$value</div>",
    "chartbottommargin":"0",
    "showChildLabels":"1",
    "labelFontColor":"#1D2737",
    "labelfont":"Roboto",
    "labelGlow": "0",
    "horizontalPadding": "1",
    "verticalPadding": "1",
    "plotborderthickness": ".1",
    "plothovereffect":"0"
}

export default function dataSourceGenerator(rawData, timeSelectorValue, theme) {
    chart = mergeObj(chart, theme);
    let dataSource = {},
        regions = [],
        data = [],
        regionsObj = {},
        totalshipment;
    for (let i = 0; i < rawData.length; i++) {
        let region = rawData[i]['customer'];
        if (!regions.includes(region)) {
            regions.push(region);
            regionsObj[region] = 1;
        } else {
            regionsObj[region]++;
        }
    }
    data = regions.map((region) => {
        return {
            "label": region,
            "value": regionsObj[region],
            "svalue": regionsObj[region],
            "plotooltext":"<div><p>Customer:"+region+"</p><p>Shipments:"+regionsObj[region]+"</p></div>"
        }
    });
    for (var prop in regionsObj) {
        totalshipment += regionsObj[prop] 
    }
    dataSource = {
        chart: chart,
        data: [{"fillcolor": '#27293d', "label":"Total Shipments", "value": totalshipment, "data": data}],
        colorrange: {
            "mapbypercent": "0",
            "gradient": "1",
            "code": "#A3A9EA",
            "color": [
                {
                    "code": "#909AE4",
                    "maxvalue": "10"
                },
                {
                    "code": "#6B7FD7",
                    "maxvalue": "100"
                },
                {
                    "code": "#6B7FD7",
                    "maxvalue": "700"
                }
            ]
        }
    }
    return dataSource
}


// WEBPACK FOOTER //
// ./src/util/dataSourceGenerators/volumnShipmentCount.js